export default __webpack_public_path__ + "static/media/decor.c85eb061.png";